import { pageNames } from "./RouteMap";

const constantsUnlockFeatureTag = {
	[pageNames.myScore.path]: "SCORE",
	[pageNames.score.path]: "SCORE",
	[pageNames.userProfile.path]: "DADOS CADASTRAIS",
};

export default constantsUnlockFeatureTag;
